import { combineReducers } from "redux";
import { MerchantStateReducer } from "../reducers/merchant";
import { UtilityConfigStateReducer } from './utility';

export const AllReducers = combineReducers({
  merchantsRegistrationState: MerchantStateReducer.RegistrationPage,
  merchantCategoryState: MerchantStateReducer.Categories,
  merchantBillerState: MerchantStateReducer.Billers,
  merchantRoleState: MerchantStateReducer.Roles,
  merchantUserState: MerchantStateReducer.Users,
  merchantProductState: MerchantStateReducer.Products,
  merchantCommissionState: MerchantStateReducer.MerchantCommission,
  utilityState: UtilityConfigStateReducer.Config,
  merchantLandingPage: MerchantStateReducer.LandingPage,
  merchantSettings: MerchantStateReducer.Settings,
  merchantWallet: MerchantStateReducer.Wallet,
  merchantReportState: MerchantStateReducer.Report,
  merchantDashboard: MerchantStateReducer.merchantDashboard,
  auditLog: MerchantStateReducer.AuditLog,
  apiLoaderState: UtilityConfigStateReducer.APILoader,
  modal: UtilityConfigStateReducer.SetModal,
  profileState: MerchantStateReducer.MerchantProfile,
  transactionState: MerchantStateReducer.Transaction,
  bulk: MerchantStateReducer.BulkAirtime
});
